import React, { useState } from "react";
import { db } from "../firebase/config";
import { collection, addDoc } from "firebase/firestore";
import "../styles/AddPost.css";
import ReactQuill from "react-quill";
import "quill/dist/quill.snow.css";

const AddPost = () => {
  const [form, setForm] = useState({
    title: "",
    content: "",
    imageUrl: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleContentChange = (value) => {
    setForm({ ...form, content: value });
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
    ],
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await addDoc(collection(db, "posts"), {
      title: form.title,
      content: form.content,
      imageUrl: form.imageUrl, // ✅ saved
      likes: [],
      dislikes: [],
      createdAt: new Date(),
    });

    alert("Post added!");
    setForm({ title: "", content: "", imageUrl: "" });
  };

  return (
    <div className="add-post-container">
      <h2>Add New Post</h2>

      <form onSubmit={handleSubmit}>
        {/* TITLE */}
        <input
          type="text"
          name="title"
          placeholder="Post Title"
          value={form.title}
          onChange={handleChange}
          required
        />

        {/* IMAGE URL */}
        <input
          type="url"
          name="imageUrl"
          placeholder="Image URL"
          value={form.imageUrl}
          onChange={handleChange}
          required
        />

        {/* PREVIEW */}
        {/* IMAGE PREVIEW */}
        {form.imageUrl && (
          <div className="image-preview">
            <img src={form.imageUrl} alt="Preview" />
          </div>
        )}

        {/* CONTENT */}
        <ReactQuill
          key={form.content} // ✅ forces reset
          value={form.content}
          onChange={handleContentChange}
          modules={modules}
          placeholder="Write something amazing..."
        />

        <button type="submit">Create Post</button>
      </form>
    </div>
  );
};

export default AddPost;
